import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
declare var $;

@Component({
  selector: 'app-warning-modal',
  templateUrl: './warning-modal.component.html',
  styleUrls: ['./warning-modal.component.scss']
})
export class WarningModalComponent implements OnInit {

  @Input() public title: string;
  @Input() public description: string;
  @Input() public callback: string;

  @Output() public goToCallback: EventEmitter<string> = new EventEmitter;

  constructor() {
  }

  ngOnInit() {
  }

  emit() {

    if (this.callback) {
      this.goToCallback.emit(this.callback);
    }
  }

  close() {

    this.emit();
    $('#warning-modal').modal('hide');
  }

  open(data) {

    this.fill(data);
    $('#warning-modal').modal('show');
  }

  fill(data) {
    this.title = data.title;
    this.description = data.description;
    this.callback = data.callback;
  }
}



// WEBPACK FOOTER //
// ./src/app/components/tools/modals/warning-modal/warning-modal.component.ts